import * as plugins from './smartstate.plugins.js';
import { combineLatest, map, distinctUntilChanged } from 'rxjs';
import type { StatePart } from './smartstate.classes.statepart.js';
import { isStateSelectionEqual } from './smartstate.helpers.equality.js';

/**
 * creates a computed observable derived from multiple state parts.
 * the observable is lazy — it only subscribes to sources when subscribed to.
 */
export function computed<TResult>(
  sources: StatePart<any, any>[],
  computeFn: (...states: any[]) => TResult,
): plugins.smartrx.rxjs.Observable<TResult> {
  return combineLatest(sources.map((sp) => sp.select())).pipe(
    map((states) => computeFn(...states)),
    distinctUntilChanged(isStateSelectionEqual),
  ) as plugins.smartrx.rxjs.Observable<TResult>;
}
